module.exports = __webpack_public_path__ + "static/8-db38df556dd4e88b39787d8bb582c166.jpg";